export const environment = {
    production: true,
    development: false,
    api: '/api',
};
